import type { TuiIconData} from '@eliboo/angular/loading';
import type { TuiContext } from '@taiga-ui/cdk';

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LoadingBaseComponent, LoadingService } from '@eliboo/angular/loading';
import { TuiIcon, TuiLoader } from '@taiga-ui/core';
import { type PolymorpheusContent, PolymorpheusOutlet } from '@taiga-ui/polymorpheus';

export interface TuiLoadingContext extends TuiContext<CustomOptions> {
  readonly key: string;
}
interface CustomOptions {
  icon?: string | TuiIconData;
  onlyText?: boolean;
  text?: PolymorpheusContent<TuiLoadingContext>;
}

@Component({
  template: `
    @if (textContent()) {
      <div class="bg-white p-4 rounded-md text-sm flex items-center justify-center flex-col">
        <!-- <tui-loader /> -->
        <span class="loading loading-infinity loading-lg text-primary"> 123123 </span>
        <div class="text-base py-0.5">
          @if (icon()) {
            <tui-icon
              [icon]="'@tui.' + icon()!.name"
              [background]="icon()?.background ?? ''"
              [style.background]="icon()?.backgroundColor ?? ''"
              [style.color]="icon()?.color ?? ''"
              [style.font-size.rem]="icon()?.size ?? 1.5"
            />
          }
          <span *polymorpheusOutlet="textContent() as text; context: this.getContext()" [innerHTML]="text"> </span>
        </div>
      </div>
    } @else {
      <tui-loader />
    }
  `,
  styles: ``,
  imports: [TuiLoader, PolymorpheusOutlet, TuiIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElibooLoadingTUIComponent extends LoadingBaseComponent<CustomOptions> {
  textContent = computed(() => this.data().text);
  icon = computed(() => {
    const data = this.data().icon;
    return typeof data === 'string' ? { name: data } : data;
  });
  getContext(): TuiLoadingContext {
    return {
      $implicit: this.data(),
      key: 'ElibooLoadingTUIComponent',
    };
  }
}

export function useLoading() {
  const loadingSrv = inject(LoadingService<CustomOptions>);
  return loadingSrv;
}
